/*
 * These are anchor tags for use in Optimizely
 * to select components
 */

const Prefix = {
  SF: 'SignupForm',
  PS: 'ProfileSetup',
  LP: 'LandingPage',
  BGC: 'BackgroundCheck',
  AC: 'ApplicationComplete',
  GSP: 'GetStartedPromotions',
  BAS: 'BankAccountSetup',
  DA: 'DownloadApp',
}

// Landing Page - ${Prefix.SF}
export const SignupForm = {
  Root: Prefix.SF.concat('__Root'),
  Title: Prefix.SF.concat('__Title'),
  ReferralSubtitle: Prefix.SF.concat('__ReferralSubtitle'),
  Email: Prefix.SF.concat('__Email'),
  Phone: Prefix.SF.concat('__Phone'),
  Zip: Prefix.SF.concat('__Zip'),
  LegalText: Prefix.SF.concat('__LegalText'),
  PrimaryAction: Prefix.SF.concat('__PrimaryAction'),
  AlreadySignedUp: Prefix.SF.concat('__AlreadySignedUp'),
}

export const LandingPage = {
  ValueProps: Prefix.LP.concat('__ValueProps'),
  Hero: Prefix.LP.concat('__Hero'),
  HeroRoot: Prefix.LP.concat('__HeroRoot'),
  Title: Prefix.LP.concat('__Title'),
  Subtitle: Prefix.LP.concat('__Subtitle'),
  FAQContainer: Prefix.LP.concat('__FAQContainer'),
  FAQCell: Prefix.LP.concat('__FAQCell'),
  FAQTitle: Prefix.LP.concat('__FAQTitle'),
}

export const ProfileSetup = {
  AltFirstName: Prefix.PS.concat('__AltFirstName'),
  AltLastName: Prefix.PS.concat('__AltLastName'),
  FirstName: Prefix.PS.concat('__FirstName'),
  MiddleName: Prefix.PS.concat('__MiddleName'),
  LastName: Prefix.PS.concat('__LastName'),
  NoMiddleNameToggle: Prefix.PS.concat('__NoMiddleNameToggle'),
  ReferralToggle: Prefix.PS.concat('__ReferralToggle'),
  ReferralPhoneField: Prefix.PS.concat('__ReferralPhoneField'),
  PasswordField: Prefix.PS.concat('__PasswordField'),
  PasswordConfirmField: Prefix.PS.concat('__PasswordConfirmField'),
  PrimaryAction: Prefix.PS.concat('__PrimaryAction'),
}

export const BackgroundCheck = {
  VehicleSelect: Prefix.BGC.concat('__VehicleSelect'),
  LicenseState: Prefix.BGC.concat('__LicenseState'),
  LicenseNumber: Prefix.BGC.concat('__LicenseNumber'),
  InsuranceCheckbox: Prefix.BGC.concat('__InsuranceCheckbox'),
  BirthdateContainer: Prefix.BGC.concat('__BirthdateContainer'),
  BirthdateMonth: Prefix.BGC.concat('__BirthdateMonth'),
  BirthdateYear: Prefix.BGC.concat('__BirthdateYear'),
  BirthdateDay: Prefix.BGC.concat('__BirthdateDay'),
  PersonalIdentificationNumber: Prefix.BGC.concat(
    '__PersonalIdentificationNumber'
  ),
  PersonalIdentificationNumberConfirm: Prefix.BGC.concat(
    '__PersonalIdentificationNumberConfirm'
  ),
  BackgroundCheckDisclosure: Prefix.BGC.concat('__BackgroundCheckDisclosure'),
  AdditionalDisclosuresDocument: Prefix.BGC.concat(
    '__AdditionalDisclosuresDocument'
  ),
  AuthAndReleaseDocument: Prefix.BGC.concat('__AuthAndReleaseDocument'),
  BackgroundCheckCopyToggle: Prefix.BGC.concat('__BackgroundCheckCopyToggle'),
  PrimaryAction: Prefix.BGC.concat('__PrimaryAction'),
}

export const ApplicationComplete = {
  Continue: Prefix.AC.concat('__Continue'),
}

export const GetStartedPromotions = {
  Continue: Prefix.GSP.concat('__Continue'),
  Title: Prefix.GSP.concat('__Title'),
}

export const BankAccountSetup = {
  Title: Prefix.BAS.concat('__Title'),
  RoutingNumber1: Prefix.BAS.concat('__RoutingNumber1'),
  CheckingAccountNumber1: Prefix.BAS.concat('__CheckingAccountNumber1'),
  NoBankAccountButton: Prefix.BAS.concat('__NoBankAccountButton'),
  PrimaryAction: Prefix.BAS.concat('__PrimaryAction'),
  SecondaryAction: Prefix.BAS.concat('__SecondaryAction'),
  BackButton: Prefix.BAS.concat('__BackButton'),
}

export const DownloadApp = {
  PrimaryAction: Prefix.DA.concat('__PrimaryAction'),
  Subheader: Prefix.DA.concat('__Subheader'),
}
